// This import loads the firebase namespace along with all its type information.
import SystemSetting from './system-setting-model'

export async function load_systemSettings(): Promise<SystemSetting[]> {
  throw 'Not implemented'
}

export async function delete_systemSetting(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_systemSetting(): Promise<SystemSetting> {
  throw 'Not implemented'
}
